import React, { useState } from 'react';
import CertifiedTutors from '../components/CertifiedTutors';
import './NooraniQaidaCourse.css';

const NooraniQaidaCourse = () => {
  const [activeFaq, setActiveFaq] = useState(null);
  const [activeStructure, setActiveStructure] = useState(0);

  const toggleFaq = (index) => {
    if (activeFaq === index) {
      setActiveFaq(null);
    } else {
      setActiveFaq(index);
    }
  };

  const toggleStructure = (index) => {
    if (activeStructure === index) {
      setActiveStructure(null);
    } else {
      setActiveStructure(index);
    }
  };

  const whyChooseCards = [
    {
      img: '/assets/images/course1/A-1.webp',
      title: 'Qualified Male and Female Teachers',
      desc: 'We have well-experienced and certified tutors for our students, who are very proficient at tutoring the new students professionally. They will ensure that all the students learn to pronounce the Arabic language correctly and have an opportunity to get an education.'
    },
    {
      img: '/assets/images/course1/A-2.webp',
      title: 'Structured Lessons for Beginners',
      desc: 'We begin from the Noorani Qaida and basic letters for the new students who have to learn to write independently. Each lesson builds on the previous one; there won’t be any confusion or lack of understanding by any student.'
    },
    {
      img: '/assets/images/course1/A-3.webp',
      title: 'One-to-One Online Classes',
      desc: 'During one-on-one classes, teachers assess students’ performance and provide them with feedback. The teachers will actively listen to the student, correct him or her, and help throughout the course of the lesson. It is an extremely effective and exciting method of learning Noorani Qaida online at home.'
    },
    {
      img: '/assets/images/course1/A-4.webp',
      title: 'Flexible Timings at Home',
      desc: 'We offer flexible timings for you or your kids. You can choose your class timings according to your own schedule, which includes evenings and weekends. This way, there will be no disruption in the routine life of the kid, as well as for adults.'
    },
    {
      img: '/assets/images/course1/A-5.webp',
      title: 'Learn In English and Arabic',
      desc: 'We offer Noorani Qaida learning in English and Arabic, so students can choose based on their comfort. This helps them to understand their lessons more effectively and follow instructions. The completion of this course depends on the child’s progress and consistently delivers improved results.'
    },
    {
      img: '/assets/images/course1/A-7.webp',
      title: 'Regular Progress Tracking',
      desc: 'Our qualified teachers assess the progress of each individual learner in this course and give feedback to parents regarding their children’s performance, along with suggestions for further practice in the areas we deem necessary.'
    }
  ];

  const courseStructure = [
    {
      title: "Foundation & Phonetics (Chapters 1–2)",
      desc: "The beginning lessons focus on learning the Arabic alphabet along with its correct pronunciation. Special focus is given to Makharij at this stage to create a strong foundation, which is a necessary step for beginners."
    },
    {
      title: "Vowels & Movements (Chapters 3–6)",
      desc: "After the phonetics, short vowels, and Harakat are introduced. We teach techniques on how they can change the sound of any letter. Students get practice in reading with correct pronunciation and voice flow. It helps students increase their accuracy level by reading simple words."
    },
    {
      title: "Connecting & Resting Sounds (Chapters 7, 8, 11 & 13)",
      desc: "In this session, learners will understand how they should connect letters to make words. They will get an understanding of the rules of Sukun and Shaddah (doubling/emphasis) in an understandable way."
    },
    {
      title: "Rules of Elongation (Chapters 9–10 & 12)",
      desc: "Rules of elongations are included in the rules of Madd, which help them recite more accurately. They learn when to stretch sounds and for how long. This makes their Quran reading natural and correct."
    },
    {
      title: "Advanced Recitation & Fluency (Chapters 14–17)",
      desc: "After all the regulations of Tajweed, students learn to recite full verses fluently. They focus on recitation with fluency and making fewer errors. At the end, they are ready to read the Quran with confidence."
    }
  ];

  const courseLevels = [
    {
      img: '/assets/images/course1/I-1.webp',
      title: 'Beginner Level (Chapters 1–6)',
      desc: 'The beginner level helps students start learning the basics of Arabic and letters. We teach them letter identification, how to pronounce, and vowels. Students get the fundamental concepts of the language.'
    },
    {
      img: '/assets/images/course1/I-2.webp',
      title: 'Middle Level (Chapters 7–13)',
      desc: 'In this level, students start forming letters into words. Students get acquainted with various principles, such as Sukoon. It helps to improve the understanding skills of the students who are studying from Noorani Qaida online.'
    },
    {
      img: '/assets/images/course1/I-3.webp',
      title: 'Advanced Level (Chapters 14–17)',
      desc: 'The advanced level is helpful in students’ progress towards fluent Quran recitation with fewer errors. They are known about proper application of all rules taught. At the conclusion of the course, students will be thoroughly prepared to read the Quran by themselves.'
    }
  ];

  const courseResults = [
    {
      img: '/assets/images/course1/WC_US-2.webp',
      alt: 'Learn Quran with Fluency',
      title: 'Clear and Correct Pronunciation',
      desc: 'Students will be able to learn the pronunciation of each Arabic letter from its proper articulation. This will help minimize errors and increase the accuracy of their recitation. The foundation is established to ensure the correct recitation of the Quranic verses.'
    },
    {
      img: '/assets/images/course1/WC_US-7.webp',
      alt: 'Learn Quran with Proper Pronunciation and Tajweed',
      title: 'Confident Quran Reading',
      desc: 'By the end of the course, the student becomes a confident reciter. Students do not falter when connecting letters or making words. This competence inspires them to keep on learning and improving.'
    },
    {
      img: '/assets/images/course1/WC_US-4.webp',
      alt: 'Confident Quran Recitation',
      title: 'Understanding of Tajweed',
      desc: 'Teachers educate the students about the basic rules of Tajweed, such as vowels, Sukun, and elongation. Students apply these rules during reading rather than memorizing them.'
    },
    {
      img: '/assets/images/course1/WC_US-6.webp',
      alt: 'Quran Classes Free Trial',
      title: 'Independent Learning Ability',
      desc: 'Students cannot learn the Noorani Qaida without having a teacher always guiding them. They will be able to practice independently and keep developing themselves. This will make it easier for them to transition to Quran reading after learning Noorani Qaida.'
    }
  ];

  const whatsIncluded = [
    {
      img: '/assets/images/course1/WC_US-5.webp',
      title: 'One-to-One Live Classes',
      desc: 'Individual classes to learn Noorani Qaida online, where students get complete attention from the instructor. These private lessons ensure quick and accurate learning in all sessions.'
    },
    {
      img: '/assets/images/course1/WC_US-7.webp',
      title: '3 Day Trial Class Option',
      desc: 'We offer a 3-day trial session before enrolling in the full Noorani Qaida course. This trial is especially made for the parents and students to understand the teaching style and class setup.'
    },
    {
      img: '/assets/images/course1/WC_US-1.webp',
      title: 'Flexible Class Scheduling',
      desc: 'Class timings are custom so you can easily suggest the time that fits your daily routine, including evenings and weekends. Perfect for students managing school, work, or family time.'
    },
    {
      img: '/assets/images/course1/WC_US-2.webp',
      title: 'Male and Female Tutors Available',
      desc: 'Students and their parents have options to pick a tutor as per their preference. It makes the whole Noorani Qaida online classes at home comfortable and convenient.'
    },
    {
      img: '/assets/images/course1/WC_US-8.webp',
      title: 'Learn Noorani Qaida In English',
      desc: 'We offer lessons to learn Noorani Qaida in English and Arabic for our students to better understand. This helps students follow instructions easily and learn faster.'
    },
    {
      img: '/assets/images/course1/WC_US-4.webp',
      title: 'Progress Tracking and Reports',
      desc: 'Teachers keep track of their students’ progress and give reports. The parents will be updated regularly about their child’s performance and practice.'
    },
    {
      img: '/assets/images/course1/WC_US-3.webp',
      title: 'Interactive Online Learning Tools',
      desc: 'We have classes that involve screen sharing, virtual whiteboard, and reading classes. These learning resources make online classes interesting.'
    },
    {
      img: '/assets/images/course1/WC_US-6.webp',
      title: 'Beginner-Friendly Lesson Structure',
      desc: 'For beginners, we offer a custom beginner-friendly online Noorani Qaida course, including this course, in which they understand the core Quran education.'
    }
  ];

  const faqs = [
    { q: 'What is Noorani Qaida?', a: 'Noorani Qaida is a basic book that helps beginners and kids learn to read the Quran in Arabic. It starts with the Arabic alphabet and teaches Tajweed rules step by step for correctly pronouncing Arabic words.' },
    {
      q: 'Is Noorani Qaida necessary before learning the Quran?',
      a: (<>
        'Yes, you need to learn Noorani Qaida before Quran reading. Then we’ll proceed to the <a style={{ color: "#006100" }} href="/online-tajweed-classes-tajweed-course/">Quran Tajweed course</a> for better Quran reading.'
      </>)
    },
    { q: 'How many lessons are in Noorani Qaida?', a: 'There are 17 chapters, starting from Arabic alphabets (Huroof e Mufridaat) through compound letters, abbreviated letters, and beyond.' },
    { q: 'How long does it take to complete Noorani Qaida?', a: 'One of the most searched questions. The course generally takes about 3–6 months, depending on the student’s ability and interest.' },
    { q: 'How many classes per week are needed?', a: 'Most students complete Noorani Qaida with 2–3 classes per week, with sessions recommended to be 20–30 minutes for young learners.' },
    { q: 'What is the minimum age to start?', a: 'Children as young as 4 years old can start Noorani Qaida. Teachers use interactive methods, games, fun activities, and rewards to keep young learners engaged.' },
    { q: 'Can adults with zero Arabic knowledge enroll?', a: 'The course is designed specifically for complete beginners with zero prior knowledge of Arabic, whether they cannot recognize a single Arabic letter or have no familiarity with Islamic education.' },
    { q: 'Can I learn Noorani Qaida online from the USA?', a: 'Online learning via a personal one-on-one teacher is increasingly popular, allowing students to learn without leaving their homes.' },
  ];

  const handleOpenChat = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('open-chat'));
    if (typeof window.openChatbot === 'function') {
      window.openChatbot();
    }
  };


  return (
    <div className="noorani-course-page">
      {/* 1. Hero Section */}
      <section
        className="noorani-hero"
        style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url('${process.env.PUBLIC_URL}/assets/images/home-banner.jpg')` }}
      >
        <div className="noorani-hero__container">
          <h1 className="noorani-hero__title">Noorani Qaida Course Online for Kids & Adults in USA</h1>
          <nav className="noorani-hero__breadcrumb">
            <a href="/">Home</a>
            <span className="separator">&gt;</span>
            <span className="current">Noorani Qaida Course</span>
          </nav>
        </div>
      </section>

      {/* 2. Join Course Section */}
      <section className="noorani-join-section">
        <div className="noorani-container two-col-layout">
          <div className="join-content">
            <h2 className="section-title-left">Join Noorani Qaida Course Online from the Comfort of Your Home</h2>
            <p className="section-desc">
              Learning Noorani Qaida is the foundational stepping stone to reading the Holy Quran with proper Tajweed. Al Quran Lesson provides structured, interactive 1-on-1 online classes designed to help beginners and kids master the Arabic alphabet, pronunciation (Makharij), and phonics from scratch. Our certified tutors guide students step-by-step, ensuring a solid base for advanced recitation.
            </p>
            <div className="join-cta-group">
              <a href="/free-trial/" className="btn-green-cta">Get a Free Trial</a>
              <button
                type="button"
                onClick={handleOpenChat}
                className="btn-outline-cta"
                style={{ cursor: 'pointer' }}
              >
                Speak Live With Experts
              </button>
            </div>
          </div>
          <div className="join-image">
            <img src={`${process.env.PUBLIC_URL}/assets/images/course1/Noorani-Qaida.jpg`} alt="Noorani Qaida Online" />
          </div>
        </div>
      </section>

      {/* 3. Stats Bar Section */}
      <section className="noorani-stats-bar">
        <div className="noorani-container stats-grid">
          <div className="stat-card">
            <h4>5,000+</h4>
            <p>Satisfied Students</p>
          </div>
          <div className="stat-card">
            <h4>20+</h4>
            <p>Expert Teachers</p>
          </div>
          <div className="stat-card">
            <h4>5+</h4>
            <p>Structured Courses</p>
          </div>
          <div className="stat-card">
            <h4>13+</h4>
            <p>Years Experience</p>
          </div>
        </div>
      </section>

      {/* 4. Learn Online Classes Section */}
      <section className="noorani-why-choose">
        <div className="noorani-container">
          <div className="section-header-center">
            <h2>Learn Noorani Qaida Online Classes At Home</h2>
          </div>
          <div className="why-choose-grid">
            {whyChooseCards.map((card, i) => (
              <div key={i} className="why-choose-card">
                <div className="why-choose-card__icon-wrapper">
                  <img src={`${process.env.PUBLIC_URL}${card.img}`} alt="Learn Quran with Proper Pronunciation and Tajweed" />
                </div>
                <h3>{card.title}</h3>
                <p>{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 5. What You Will Learn Section / Course Structure */}
      <section className="noorani-learn-section">
        <div className="noorani-container">
          <div className="section-header-center">
            <h2>Our Noorani Qaida Course Structure</h2>
            <p>We’ve designed our Noorani Qaida course in a way that helps students learn to read the Holy Quran through an easy-to-follow process. Our every lesson gives Quran education, making it easier for any beginner to learn.</p>
          </div>

          <div className="two-col-layout">
            <div className="learn-image">
              <img src={`${process.env.PUBLIC_URL}/assets/images/course1/Img-11.jpg`} alt="Our Noorani Qaida Course Structure" />
            </div>
            <div className="outline-right-accordion">
              {courseStructure.map((item, i) => (
                <div key={i} className={`structure-accordion-item ${activeStructure === i ? 'active' : ''}`}>
                  <button className="structure-accordion-header" onClick={() => toggleStructure(i)}>
                    <h3 className="structure-title">{item.title}</h3>
                    <span className="structure-icon-circle">
                      <span className="structure-icon">{activeStructure === i ? '−' : '+'}</span>
                    </span>
                  </button>
                  <div className="structure-accordion-body">
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="center-btn-wrapper">
            <a href="/free-trial/" className="btn-pill-outline">
              Start Your Journey Now <span className="btn-arrow">→</span>
            </a>
          </div>
        </div>
      </section>

      {/* 6. Mid CTA Banner */}
      <section className="noorani-mid-cta">
        <div className="noorani-container mid-cta-grid">
          <div className="mid-cta-text">
            <h2>Start Learning Noorani Qaida Online At Home Today With a Free 3-Day Trial!</h2>
            <a href="/free-trial/" className="btn-yellow-cta">Book Your 3-Day Free Trial</a>
          </div>
          <div className="mid-cta-image">
            <img src={`${process.env.PUBLIC_URL}/assets/images/course1/Img-1.png`} alt="Islamic Teacher" />
          </div>
        </div>
      </section>

      {/* 7. 3 Levels Section */}
      <section className="noorani-levels-section">
        <div className="noorani-container">
          <div className="section-header-center">
            <h2>3 Levels Of Noorani Qaida Course</h2>
          </div>
          <div className="outline-grid">
            {courseLevels.map((level, i) => (
              <div key={i} className="level-card">
                <div className="level-card__icon-wrapper">
                  <img src={`${process.env.PUBLIC_URL}${level.img}`} alt={level.title} />
                </div>
                <h3>{level.title}</h3>
                <p>{level.desc}</p>
                <div className="level-card__divider-line"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 8. Results Section */}
      <section className="noorani-results-section">
        <div className="noorani-container">
          <div className="section-header-center">
            <h2>Results Of Our Noorani Qaida Course</h2>
            <p>Our online Noorani Qaida course is helpful for students to improve their basic Arabic knowledge. This course provides effective and long-term outcomes.</p>
          </div>
          <div className="noorani-results-layout two-col-layout">
            <div className="results-left-cards">
              {courseResults.map((item, i) => (
                <div key={i} className="result-item-card">
                  <div className="result-item-card__icon">
                    <img src={`${process.env.PUBLIC_URL}${item.img}`} alt={item.alt} />
                  </div>
                  <div className="result-item-card__content">
                    <h3>{item.title}</h3>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="results-right-image">
              <img src={`${process.env.PUBLIC_URL}/assets/images/course1/A10.jpg`} alt="Online Quran Tajweed Course - Al Quran Lesson" />
            </div>
          </div>
        </div>
      </section>

      {/* 11. Certified Tutors Section */}
      <CertifiedTutors />

      {/* 12. Enroll Banner */}
      <section className="noorani-enroll-banner">
        <div className="noorani-container enroll-banner-grid">
          <div className="enroll-banner-text">
            <h2>Enroll in Noorani Qaida Online Course Today!</h2>
            <a href="/free-trial/" className="btn-white-cta">Get Registered Now</a>
          </div>
          <div className="enroll-banner-image">
            <img src={`${process.env.PUBLIC_URL}/assets/images/course1/Al.png`} alt="Quran Tutor" />
          </div>
        </div>
      </section>

      {/* 12. What's Included Section */}
      <section className="noorani-whats-included">
        <div className="noorani-container">
          <div className="section-header-center">
            <div className="whats-included__badge-wrapper">
              <span className="whats-included__badge">Why Choose Al Quran Lesson?</span>
            </div>
            <h2>What Is Included In Our Online Noorani Qaida Course We Offer</h2>
            <p>We ensure that everything is easy, efficient, and successful. With personalized lessons, as well as flexible timing, and Noorani Qaida online classes at home, everything is provided in order to help you receive conceptual knowledge online. We emphasize providing our students with a safe and professional environment to learn.</p>
          </div>
          <div className="whats-included-grid">
            {whatsIncluded.map((item, i) => (
              <div key={i} className="included-card">
                <div className="included-card__icon">
                  <img src={`${process.env.PUBLIC_URL}${item.img}`} alt={item.title} />
                </div>
                <div className="included-card__content">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 13. FAQ Accordion Section */}
      <section className="noorani-faq-section">
        <div className="noorani-container two-col-layout">
          <div className="faq-content">
            <h2 className="section-title-left">Frequently Asked Questions</h2>
            <p className="section-desc">Got questions? We have compiled answers to common inquiries below:</p>

            <div className="faq-accordion-list">
              {faqs.map((faq, i) => (
                <div key={i} className={`faq-accordion-item ${activeFaq === i ? 'active' : ''}`}>
                  <button className="faq-accordion-question" onClick={() => toggleFaq(i)}>
                    {faq.q}
                    <span className="faq-accordion-icon">{activeFaq === i ? '−' : '+'}</span>
                  </button>
                  <div className="faq-accordion-answer">
                    <p>{faq.a}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="faq-image">
            <img src={`${process.env.PUBLIC_URL}/assets/images/course1/qari.png`} alt="FAQ Support" />
          </div>
        </div>
      </section>


    </div>
  );
};

export default NooraniQaidaCourse;

